export { HistoryService } from "./history-service";
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../es/services/index.js
// module id = 1137
// module chunks = 0